/**
 * Pickup punkt kontraktlari (Faza 5/6) — public ro'yxat (buyer) + admin CRUD (POS).
 *
 * pickup_points GLOBAL jadval (RLS yo'q). Lokatsiya: geoLat/geoLng — admin
 * xaritada belgilaydi, buyer xaritada ko'rib eng yaqinini tanlaydi, buyurtma
 * FAQAT tanlangan punktga boradi (Order.pickupPointId).
 */
import { z } from 'zod';
export const pickupPointsQuerySchema = z.object({
    region: z.string().trim().max(120).optional(),
});
// ─── Admin (POS) — punkt yaratish/tahrirlash ──────────────────────
// Lokatsiya O'zbekiston chegarasida (taxminiy) — admin xaritani bosib belgilaydi.
const latSchema = z.number().min(-90).max(90);
const lngSchema = z.number().min(-180).max(180);
export const createPickupPointSchema = z.object({
    name: z.string().trim().min(1, 'Nom kerak').max(160),
    region: z.string().trim().min(1, 'Viloyat kerak').max(120),
    district: z.string().trim().min(1, 'Tuman kerak').max(120),
    address: z.string().trim().min(1, 'Manzil kerak').max(300),
    geoLat: latSchema.nullable().optional(),
    geoLng: lngSchema.nullable().optional(),
    workingHours: z.string().trim().max(120).nullable().optional(),
    partnerName: z.string().trim().max(160).nullable().optional(),
    phone: z.string().trim().max(20).nullable().optional(),
    isActive: z.boolean().optional(),
    // Uy-yetkazish radiusi (km) — buyer shu masofa ichida bo'lsa kuryer yetkazadi
    deliveryRadiusKm: z.number().int().min(1, 'Kamida 1 km').max(500).optional(),
});
export const updatePickupPointSchema = createPickupPointSchema.partial();
// ─── Punkt operatori akkaunti (PLATFORM_ADMIN punktga operator yaratadi) ──
export const createPickupOperatorSchema = z.object({
    username: z
        .string()
        .trim()
        .min(3, 'Login kamida 3 belgi')
        .max(50)
        .regex(/^[a-zA-Z0-9_]+$/, 'Faqat harf, raqam va _'),
    password: z.string().min(6, 'Parol kamida 6 belgi').max(100),
    name: z.string().trim().min(1, 'Ism kerak').max(120),
});
//# sourceMappingURL=marketplace-pickup.schema.js.map